exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".multiselect__tags[data-v-3603bd66]{min-height:32px;display:block;padding:3px 40px 0 8px;border-radius:5px;border:1px solid #e8e8e8;background:#000!important;font-size:14px}", ""]);

// exports
